import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b9697ace"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-area company-dashboard pt-120 mb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = { class: "table-wrapper2" }
const _hoisted_6 = { class: "title-and-btn" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Plan & Invoice List:")
], -1))
const _hoisted_8 = { class: "eg-table table plan-invoice-table mb-0" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { width: "50" }, "#"),
    /*#__PURE__*/_createElementVNode("th", null, "Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Package"),
    /*#__PURE__*/_createElementVNode("th", null, "Amount"),
    /*#__PURE__*/_createElementVNode("th", null, "Payment Through"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th", null, "Download"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1))
const _hoisted_10 = { class: "style-2" }
const _hoisted_11 = { "data-label": "(#) Number" }
const _hoisted_12 = { "data-label": "Date" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { "data-label": "Package" }
const _hoisted_15 = { class: "eg-btn light-yellow-btn pkg-name" }
const _hoisted_16 = { "data-label": "Amount" }
const _hoisted_17 = {
  key: 0,
  "data-label": "Payment Through"
}
const _hoisted_18 = {
  key: 1,
  "data-label": "Payment Through"
}
const _hoisted_19 = { "data-label": "Payment Status" }
const _hoisted_20 = { "data-label": "Payment" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-download wp-subs-btn" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "action" }
const _hoisted_25 = {
  key: 0,
  class: "badge bg-danger"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { colspan: "4" }, " No result found... ", -1))
const _hoisted_29 = [
  _hoisted_28
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_company_menu = _resolveComponent("company-menu")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_company_menu),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", null, [
                _createVNode(_component_router_link, {
                  class: "primry-btn-2 lg-btn w-unset",
                  to: "/plans"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.companySubscriptions.length > 0 ? 'Upgrade Plan': 'Purchase Plan'), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("table", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("tbody", null, [
                (_ctx.companySubscriptions.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.companySubscriptions, (subscription) => {
                      return (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                        _createElementVNode("td", _hoisted_11, _toDisplayString(subscription.id), 1),
                        _createElementVNode("td", _hoisted_12, [
                          _createTextVNode("Creation : " + _toDisplayString(_ctx.formatDate(subscription.created_at)), 1),
                          _hoisted_13,
                          _createTextVNode(" Expiry : " + _toDisplayString(_ctx.formatDate(subscription.ends_at)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_14, [
                          _createElementVNode("button", _hoisted_15, _toDisplayString(subscription.package?.name), 1)
                        ]),
                        _createElementVNode("td", _hoisted_16, "WST $" + _toDisplayString(subscription.stripe_price ?? 0), 1),
                        (subscription.subscription_status != 1)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_17, _toDisplayString(subscription.package?.stripe_price_id ? subscription.brand + ' card - ' + subscription.last_4 : 'Offline Method'), 1))
                          : (_openBlock(), _createElementBlock("td", _hoisted_18, " Direct Deposit ")),
                        _createElementVNode("td", _hoisted_19, [
                          _createElementVNode("span", {
                            class: _normalizeClass({
                                            'badge bg-danger': new Date(subscription.ends_at) < new Date() || subscription.status === 'unsubscribed',
                                            'badge bg-warning': subscription.status === 'pending',
                                            'badge bg-success': new Date(subscription.ends_at) >= new Date() && subscription.status !== 'unsubscribed' && subscription.status !== 'pending' })
                          }, _toDisplayString(subscription.status === 'pending' ? 'Pending' :
                                                (new Date(subscription.ends_at) < new Date() || subscription.status === 'unsubscribed' ? 'Expired' : 'Active')), 3)
                        ]),
                        _createElementVNode("td", _hoisted_20, [
                          (subscription.receipt_url)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: _normalizeClass({'status':true, 'yellow-color': true}),
                                onClick: ($event: any) => (_ctx.getReceipt(subscription.receipt_url))
                              }, _hoisted_23, 8, _hoisted_21))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", _hoisted_24, [
                          (subscription.status == 'unsubscribed')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Unsubscribed"))
                            : (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                class: "status yellow-color wp-subs-btn",
                                onClick: ($event: any) => (_ctx.unsubscribe({'subscription_id': subscription.id}))
                              }, "Unsubscribe", 8, _hoisted_26))
                        ])
                      ]))
                    }), 256))
                  : (_openBlock(), _createElementBlock("tr", _hoisted_27, _hoisted_29))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}